export const cards = {
    primary: {
        boxShadow: 'card',
        bg: 'neutralBg',
    },
    // TODO rename the property to not contain white
    whiteContainer: {
        p: 'xl',
        borderWidth: 'default',
        borderStyle: 'solid',
        borderColor: 'neutralBorder',
        bg: 'neutralBg',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvY2FyZHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBdUM7SUFDdkQsT0FBTyxFQUFFO1FBQ1AsU0FBUyxFQUFFLE1BQU07UUFDakIsRUFBRSxFQUFFLFdBQVc7S0FDaEI7SUFDRCxnREFBZ0Q7SUFDaEQsY0FBYyxFQUFFO1FBQ2QsQ0FBQyxFQUFFLElBQUk7UUFDUCxXQUFXLEVBQUUsU0FBUztRQUN0QixXQUFXLEVBQUUsT0FBTztRQUNwQixXQUFXLEVBQUUsZUFBZTtRQUM1QixFQUFFLEVBQUUsV0FBVztLQUNoQjtDQUNGLENBQUMifQ==